import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { NavLink } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Typography from "@material-ui/core/Typography";
import Collapse from "@material-ui/core/Collapse";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import Tooltip from "@material-ui/core/Tooltip";
import Icon from '@material-ui/core/Icon';
import {
  faPuzzlePiece,
  faAd,
  faGamepad,
  faUserPlus,
  faChartLine,
  faUsers,
  faUserCheck,
  faStore,
  faTable,
  faCoins,
  faUser,
  faListAlt,
  faClone,
  faMap,
  faHamburger,
  faPaintBrush,
  faDragon,
  faWheatAwn,
  faWandSparkles,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as H from "helper";
import SidebarItemStyles from "./SidebarItemStyles";
import FiberNewIcon from '@material-ui/icons/FiberNew';

class SidebarItem extends Component {
  componentDidMount() {
    if (
      !this.props.currentPath ||
      this.props.activeRoute === this.props.index ||
      this.props.route.path === "/"
    )
      return;
    this.props.toggleMenu(this.props.index);
    this.props.toggleSubMenu(this.props.subIndex);
  }

  resolveSubmenuKey(route, subitem) {
    return `${route.path ? route.path : ""}${subitem.path ? subitem.path : ""}`;
  }

  resolveMenuPath(parentPath, item) {
    if (item.absolutePath) {
      return item.absolutePath;
    }
    return `${parentPath ? parentPath : ""}${item.path ? item.path : ""}`;
  }

  handleSubMenuClick = (event, itemPath, toggleSubMenu) => {
    event.preventDefault();
    event.stopPropagation();
    if (event.nativeEvent && typeof event.nativeEvent.stopImmediatePropagation === "function") {
      event.nativeEvent.stopImmediatePropagation();
    }
    toggleSubMenu(itemPath);
  };

  renderMenuChildren = (parentPath, items, opened, classes, activeSubRoute, toggleSubMenu, toggleDrawer, badge, depth = 0) => {
    return items.map((item, index) => {
      const itemPath = this.resolveMenuPath(parentPath, item);
      const activePath = String(activeSubRoute || "");

      if (item.type === "submenu") {
        const isOpen = activePath === itemPath || activePath.indexOf(`${itemPath}/`) === 0;
        const labelClass = depth === 0 ? classes.subMenuLabel : classes.subMenuLabel2;

        return (
          <div
            className={isOpen ? classes.menuCollapsed : classes.menuClosed}
            key={itemPath || index}
            onClick={(event) => event.stopPropagation()}
          >
            {item.category &&
              <div className={classes.categoryLbl}>
                {item.category}
              </div>
            }
            <ListItem
              className={classes.menuItem}
              button
              onClick={(event) => this.handleSubMenuClick(event, itemPath, toggleSubMenu)}
              style={{marginLeft:"-12px"}}
            >
              {!opened ? (
                <Tooltip
                  title={H.FormatNumStrHelper.capitalize(item.name)}
                  placement="right"
                >
                  <ListItemIcon>
                    {this.getIcon(item, classes)}
                  </ListItemIcon>
                </Tooltip>
              ) : (
                <ListItemIcon>{this.getIcon(item, classes)}</ListItemIcon>
              )}
              <Typography
                variant="body2"
                className={classNames(labelClass, "flexSpacer")}
              >
                {H.FormatNumStrHelper.capitalize(item.name)}
              </Typography>
              {badge(item.badge)}
              <ListItemIcon className={classes.caretSub}>
                {isOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
              </ListItemIcon>
            </ListItem>
            <Collapse in={isOpen} timeout="auto" unmountOnExit>
              <List disablePadding>
                {this.renderMenuChildren(itemPath, item.children || [], opened, classes, activeSubRoute, toggleSubMenu, toggleDrawer, badge, depth + 1)}
              </List>
            </Collapse>
          </div>
        );
      }

      return (
        <NavLink
          to={itemPath}
          exact
          className={classes.menuLink}
          activeClassName={classes.menuActive}
          key={itemPath || index}
        >
          {item.category &&
            <div className={classes.categoryLbl}>
              {item.category}
            </div>
          }
          <ListItem className={classes.menuItem} button>
            {!opened ? (
              <Tooltip
                title={H.FormatNumStrHelper.capitalize(item.name)}
                placement="right"
              >
                <ListItemIcon></ListItemIcon>
              </Tooltip>
            ) : (
              <ListItemIcon></ListItemIcon>
            )}
            <Typography
              variant="body2"
              className={classNames(
                depth === 0 ? classes.subMenuLabel : classes.subMenuLabel2,
                "flexSpacer"
              )}
            >
              {H.FormatNumStrHelper.capitalize(item.name)}
              {item.new &&
                <Icon className={classes.newIcon} style={{ marginLeft:4 }}>
                  <FiberNewIcon />
                </Icon>
              }
            </Typography>
            {badge(item.badge)}
          </ListItem>
        </NavLink>
      );
    });
  }

  getIcon(route, classes) {
    if (typeof route.icon === "object") {
      return <route.icon className={classes.menuIcon} />;
    } else if (route.icon === null) {
      return <route.icon />;
    } else {
      let faIcon = faStore;
      if (route.icon === "fa ad") {
        faIcon = faAd;
      } else if (route.icon === "fa gamepad") {
        faIcon = faClone;
      } else if (route.icon === "fa puzzle") {
        faIcon = faPuzzlePiece;
      } else if (route.icon === "fa user-plus") {
        faIcon = faUserPlus;
      } else if (route.icon === "fa chart-line") {
        faIcon = faChartLine;
      } else if (route.icon === "fa users") {
        faIcon = faListAlt;
      } else if (route.icon === "table") {
        faIcon = faTable;
      } else if (route.icon === "luckyfarmer") {
        faIcon = faWheatAwn;
      } else if (route.icon === "audience") {
        faIcon = faUsers;
      } else if (route.icon === "activeUsers") {
        faIcon = faUserCheck;
      } else if (route.icon === "kamuiVerse") {
        faIcon = faMap;
      } else if (route.icon === "cookinburger") {
        faIcon = faHamburger;
      } else if (route.icon === "dragonRamen") {
        faIcon = faDragon;
      } else if (route.icon === "graffitiracer") {
        faIcon = faPaintBrush;
      } else if (route.icon === "soulfusers") {
        faIcon = faWandSparkles;
      } else if (route.icon === "roguerollrulers") {
        faIcon = faCoins;
      }

      if (route.icon === "bouncybunny") {
        return <i className={classNames(classes.menuIconFa, "fa fa-bunny fa-lg")}></i>
      } else {
        return !route.icon ? null : <FontAwesomeIcon className={classes.menuIconFa} icon={faIcon} />;
      }
    }
  }

  render() {
    const {
      classes,
      route,
      index,
      activeRoute,
      activeSubRoute,
      toggleMenu,
      toggleSubMenu,
      isProfileMenu,
      disableMenu,
      opened,
      toggleDrawer,
    } = this.props;

    const badge = (badge) => {
      if (!badge) return;
      const badgeClassName = classNames(classes.badge, {
        [classes[`${badge.type}`]]: badge.type !== "default",
      });
      return (
        <Typography
          className={classNames(classes.badge, badgeClassName)}
          component="div"
        >
          {badge.value}
        </Typography>
      );
    };

    if (route.type === "submenu") {
      return (
        <div
          className={
            activeRoute === index ? classes.menuCollapsed : classes.menuClosed
          }
        >
          <ListItem
            className={classes.menuItemExpand}
            button
            key={index}
            onClick={() => {
              toggleMenu(index);
              toggleDrawer(route.type);
            }}
          >
            {!opened ? (
              <Tooltip
                title={H.FormatNumStrHelper.capitalize(route.name)}
                placement="right"
              >
                <ListItemIcon>{this.getIcon(route, classes)}</ListItemIcon>
              </Tooltip>
            ) : (
              <ListItemIcon>{this.getIcon(route, classes)}</ListItemIcon>
            )}
            <Typography variant="body2" className="flexSpacer-left">
              {H.FormatNumStrHelper.capitalize(route.name)}
            </Typography>
            {badge(route.badge)}
            <ListItemIcon className={classes.caret}>
              {activeRoute === index ? (
                <ArrowDropUpIcon />
              ) : (
                <ArrowDropDownIcon />
              )}
            </ListItemIcon>
          </ListItem>
          <Collapse
            in={activeRoute === index
              ? opened ? true : false
              : false}
            timeout="auto"
            unmountOnExit
          >
            <List disablePadding>
              {this.renderMenuChildren(route.path, route.children, opened, classes, activeSubRoute, toggleSubMenu, toggleDrawer, badge)}
            </List>
          </Collapse>
        </div>
      );
    }

    return (
      <NavLink
        to={disableMenu ? "#" : route.path}
        exact
        className={classes.menuLink}
        activeClassName={classes.menuActive}
        key={index}
      >
        {isProfileMenu ? (
          <ListItem
            className={classes.profileMenuItem}
            button
            onClick={() => toggleMenu(index)}
          >
            <Typography variant="body2" className="flexSpacer-left">
              {H.FormatNumStrHelper.capitalize(route.name)}
            </Typography>
            {badge(route.badge)}
          </ListItem>
        ) : !opened ? (
          <ListItem
            className={classes.menuItem}
            button
            onClick={() => toggleMenu(index)}
            disabled={disableMenu}
          >
            <Tooltip
              title={H.FormatNumStrHelper.capitalize(route.name)}
              placement="right"
            >
              <ListItemIcon>{this.getIcon(route, classes)}</ListItemIcon>
            </Tooltip>
            <Typography variant="body2" className="flexSpacer">
              {H.FormatNumStrHelper.capitalize(route.name)}
            </Typography>
          </ListItem>
        ) : (
          <ListItem
            className={classes.menuItem}
            button
            onClick={() => toggleMenu(index)}
            disabled={disableMenu}
          >
            <ListItemIcon>{this.getIcon(route, classes)}</ListItemIcon>
            <Typography variant="body2" className="flexSpacer">
              {H.FormatNumStrHelper.capitalize(route.name)}
            </Typography>
          </ListItem>
        )}
      </NavLink>
    );
  }
}

SidebarItem.prototypes = {
  classes: PropTypes.object.isRequired,
  route: PropTypes.object,
  index: PropTypes.number,
  activeRoute: PropTypes.number,
  toggleMenu: PropTypes.func,
};

export default withStyles(SidebarItemStyles)(SidebarItem);
